import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center mb-2 bg-white rounded-xl border border-gray-300 border-solid" }
const _hoisted_2 = { class: "flex flex-col justify-center w-full rounded-xl" }
const _hoisted_3 = {
  class: "flex justify-between items-center self-stretch my-auto w-5",
  "aria-label": "Toggle search filters section"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col w-full px-6 pb-5 rounded-xl max-md:px-5 overflow-hidden transition-[height] duration-300 ease-in-out",
  ref: "collapsible"
}
const _hoisted_6 = { class: "flex flex-col mb-4 mt-4 text-left pb-4" }
const _hoisted_7 = { class: "flex flex-col mb-2" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = { class: "ml-3 text-sm font-medium text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseLabel = _resolveComponent("BaseLabel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "flex gap-10 justify-between items-center px-6 py-5 rounded-xl w-full bg-slate-50 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args)))
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex items-center gap-2" }, [
          _createElementVNode("div", { class: "flex items-center justify-center w-6 h-6 rounded-full bg-gray-200 text-black font-semibold text-sm" }, " 5 "),
          _createElementVNode("h3", { class: "text-sm font-semibold text-black" }, "Search Filters")
        ], -1)),
        _createElementVNode("button", _hoisted_3, [
          _createElementVNode("div", {
            innerHTML: _ctx.isCollapsed ? _ctx.ARROW_DOWN : _ctx.ARROW_UP
          }, null, 8, _hoisted_4)
        ])
      ]),
      _createVNode(_Transition, {
        name: "expand",
        onEnter: _ctx.startExpandTransition,
        onAfterEnter: _ctx.endExpandTransition,
        onBeforeLeave: _ctx.startCollapseTransition,
        onAfterLeave: _ctx.endCollapseTransition
      }, {
        default: _withCtx(() => [
          (!_ctx.isCollapsed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_BaseLabel, {
                      forAttr: "searchFiltersToggle",
                      text: "Enable search filters to allow users to filter experts by name, title, and other criteria.",
                      class: "font-inter text-sm font-medium leading-normal tracking-normal mb-2"
                    }),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("label", _hoisted_9, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: _ctx.showSearchFilters,
                          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSearchFilters && _ctx.toggleSearchFilters(...args))),
                          class: "sr-only peer"
                        }, null, 40, _hoisted_10),
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-purple/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-purple" }, null, -1)),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.showSearchFilters ? "Enabled" : "Disabled"), 1)
                      ])
                    ])
                  ])
                ])
              ], 512))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"])
    ])
  ]))
}